module.exports = __webpack_public_path__ + "static/media/player-double-attack.a2bdd980.mp3";